import { Routes, Route } from "react-router-dom";
import Home from './pages/Home'
import About from './pages/About'
import Blog from './pages/Blog'
import Contact from './pages/Contact'
import NoPage from './pages/NoPage'
// import Jobs from './pages/Jobs'




export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/Contact" element={<Contact />} />
        {/* <Route path="/Jobs" element={<Jobs />} /> */}
        <Route path="*" element={<NoPage />} />
      </Routes>
    </div>
  );
}
